import React from "react";
import { Popover, ArrowContainer } from "react-tiny-popover";

const OpPopover = (props) => {
  return (
    <Popover
      isOpen={props.isOpen || props.isPopOverVisible}
      positions={props.positions}
      align={props.align}
      // onClickOutside={() => props.setOpen(false)}
      content={({ position, childRect, popoverRect }) => (
        <ArrowContainer // if you'd like an arrow, you can import the ArrowContainer!
          position={position}
          childRect={childRect}
          popoverRect={popoverRect}
          arrowColor={props.arrowColor || "white"}
          arrowSize={props.arrowSize || 10}
          arrowStyle={props.arrowStyle || { opacity: 1 }}
        >
          {props.children}
        </ArrowContainer>
      )}
    >
      <div onClick={() => props.setOpen(!props.isOpen)}>
        {props.targtElement}
      </div>
    </Popover>
  );
};

export default OpPopover;



// WEBPACK FOOTER //
// ./src/new/Components/PopOver/Popover.jsx